import { BedDouble, Ship, UtensilsCrossed } from "lucide-react";

const stays = (days) => days.reduce((acc, d) => {
  if (!d.overnight) return acc;
  const last = acc[acc.length - 1];
  if (last && last.place === d.overnight && last.stay === d.stay) { last.nights += 1; last.to = d.day; }
  else acc.push({ place: d.overnight, stay: d.stay, nights: 1, from: d.day, to: d.day });
  return acc;
}, []);

const ferries = (days) => days.flatMap((d) => (d.transfers || []).filter((t) => /ferry|boat/i.test(t)).map((t) => ({ day: d.day, t })));

const Block = ({ icon: Icon, title, children, testId }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid={testId}>
    <p className="flex items-center gap-2 font-semibold text-navy"><Icon className="h-4 w-4 text-ocean" />{title}</p>
    <div className="mt-4">{children}</div>
  </div>
);

export const StayFerryDetails = ({ days }) => {
  const s = stays(days);
  const f = ferries(days);
  const meals = [...new Set(days.map((d) => d.meals).filter(Boolean))];
  if (!s.length && !f.length) return null;
  return (
    <div data-testid="package-stay-ferry">
      <p className="eyebrow">Hotel &amp; ferry details</p>
      <h2 className="mt-2 font-display text-3xl sm:text-4xl text-navy font-semibold">Where you'll stay and how you'll travel</h2>
      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <Block icon={BedDouble} title="Hotel stays" testId="package-hotel-details">
          <ul className="space-y-3">
            {s.map((x) => (
              <li key={`${x.place}-${x.from}`} className="flex gap-3 text-sm">
                <span className="shrink-0 rounded-full bg-sky-50 px-2.5 py-0.5 font-mono text-xs font-semibold text-ocean">{x.nights}N</span>
                <span className="text-slate-600"><span className="font-semibold text-navy">{x.place}</span>{x.stay && ` · ${x.stay}`}
                  <span className="block text-xs text-slate-400">Night {x.from}{x.to > x.from ? `–${x.to}` : ""}</span></span>
              </li>
            ))}
          </ul>
          {meals.length > 0 && <p className="mt-4 pt-4 border-t border-slate-100 flex gap-2 text-sm text-slate-600"><UtensilsCrossed className="h-4 w-4 text-ocean shrink-0 mt-0.5" /><span><span className="font-semibold text-navy">Meals:</span> {meals.join(" / ")}</span></p>}
        </Block>
        <Block icon={Ship} title="Ferry & boat transfers" testId="package-ferry-details">
          {f.length ? (
            <ul className="space-y-3">
              {f.map((x, i) => <li key={i} className="flex gap-3 text-sm text-slate-600"><span className="shrink-0 rounded-full bg-sky-50 px-2.5 py-0.5 font-mono text-xs font-semibold text-ocean">Day {x.day}</span>{x.t}</li>)}
            </ul>
          ) : <p className="text-sm text-slate-600">No inter-island ferry in this package. Road transfers are listed in the day-wise itinerary.</p>}
          <p className="mt-4 pt-4 border-t border-slate-100 text-xs text-slate-500">Ferry timings are confirmed at booking and depend on operator schedules, weather and sea conditions.</p>
        </Block>
      </div>
    </div>
  );
};
